'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConsoleLayout = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _layout = require('antd/lib/layout');

var _layout2 = _interopRequireDefault(_layout);

var _sider = require('../../components/sider');

var _header = require('../../components/header');

var _basicLayout = require('../basicLayout');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var COLLAPSED_KEY = 'beatle_console_sidebar';

var ConsoleLayout = exports.ConsoleLayout = (_temp = _class = function (_BasicLayout) {
  _inherits(ConsoleLayout, _BasicLayout);

  function ConsoleLayout(props) {
    _classCallCheck(this, ConsoleLayout);

    var _this = _possibleConstructorReturn(this, (ConsoleLayout.__proto__ || Object.getPrototypeOf(ConsoleLayout)).call(this, props));

    _this.state = {
      inited: true,
      collapsed: window.localStorage && window.localStorage.getItem(COLLAPSED_KEY) === 'true' || false
    };
    return _this;
  }

  _createClass(ConsoleLayout, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var collapseCfg = {
        collapsed: this.state.collapsed,
        onCollapse: function onCollapse(collapsed) {
          // if (this.state.inited && this.state.collapsed) {
          //   this.setState({inited: false});
          //   return;
          // }
          _this2.setState({ collapsed: collapsed, inited: false });
          window.localStorage && window.localStorage.setItem(COLLAPSED_KEY, collapsed);
        }
      };
      var Sider = this.getComponent('Sider');
      var BLink = this.getComponent('Link');
      var Header = this.getComponent('Header');

      return _react2.default.createElement(
        'div',
        { className: 'j-layout-console ' + this.props.className, style: this.props.style },
        _react2.default.createElement(
          _layout2.default,
          { className: 'ant-layout-has-sider' },
          _react2.default.createElement(Sider, _extends({}, collapseCfg, { Link: BLink })),
          _react2.default.createElement(
            _layout2.default,
            null,
            _react2.default.createElement(Header, collapseCfg),
            _react2.default.createElement(
              _layout2.default.Content,
              null,
              this.props.viewContent || this.props.children
            )
          )
        )
      );
    }
  }]);

  return ConsoleLayout;
}(_basicLayout.BasicLayout), _class.displayName = 'ConsoleLayout', _class.layoutBlocks = {
  Header: _header.Header,
  Link: _reactRouter.Link,
  Sider: _sider.Sider
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/layouts/consoleLayout/index.jsx
// module id = 51
// module chunks = 0